import { Fragment, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { CertificatesTable } from "../components/CertificatesTable";
import { UserCertificatesTable } from "../components/UserCertificatesTable";
import { UserCertificatesExpiredTable } from "../components/UserCertificatesExpiredTable";
import { UserCertificatesExpringTable } from "../components/UserCertificatesExpringTable";
import { PageTitleController } from "../components/PageTitleController";
import { BsPatchCheckFill } from "react-icons/bs";
import { useLocation } from "react-router-dom";

export const CertificatesManagement = () => {
  const historyKey = "CertificatesManagement";

  let { state } = useLocation();
  const getKeyStartingState = () => {
    if (state === null || state === undefined) return "certs";
    if (state.hasOwnProperty("redirectKey")) return state.redirectKey;
    return "certs";
  };

  let history = localStorage.key("history")
    ? JSON.parse(localStorage.getItem("history"))
    : null;
  if (history !== null && historyKey in history)
    history = JSON.parse(history[historyKey]);
  else history = null;

  if (
    history !== null &&
    history?.lastUpdated !== undefined &&
    new Date() - new Date(history.lastUpdated) > 600000
  ) {
    localStorage.removeItem("history");
    history = null;
  }

  const [key, setKey] = useState(
    history ? history?.key : getKeyStartingState(),
  );

  useEffect(() => {
    document.title = "Certificates";
  }, []);

  return (
    <Fragment>
      <PageTitleController
        title={"Certificates"}
        icon={<BsPatchCheckFill className={"icon-right-spacing"} />}
      />
      <Tabs
        id="shifts-table-tabs"
        activeKey={key}
        onSelect={(k) => {
          var saveStates = {};
          saveStates[historyKey] = JSON.stringify({
            key: k,
            lastUpdated: new Date(),
          });
          localStorage.setItem("history", JSON.stringify(saveStates));

          setKey(k);
        }}
        className="mb-3 mb-3"
      >
        <Tab eventKey="certs" title="Certificates">
          <CertificatesTable />
        </Tab>

        <Tab eventKey="user-certs" title="User Certificates">
          <UserCertificatesTable allowUserSelection={true} />
        </Tab>

        <Tab eventKey="expired-certs" title="Expired Certificates">
          <UserCertificatesExpiredTable allowUserSelection={true} />
        </Tab>

        <Tab eventKey="expiring-30-certs" title="Expiring 30 days">
          <UserCertificatesExpringTable allowUserSelection={true} days={30} />
        </Tab>
      </Tabs>
    </Fragment>
  );
};
